import { dateFormat } from '@/utils/utils.js'
export const getOptionConfig = (barData, lang, type, that) => {
  let xAxis = []
  let data = []
  barData.forEach(element => {
    let timeStr =
      type === 90
        ? that.$t(
          'statistics.months.month' +
              dateFormat(new Date(parseInt(element.fieldKey)), 'MM')
        )
        : dateFormat(new Date(parseInt(element.fieldKey)), 'MM/dd')
    xAxis.push(timeStr)
    data.push(element.count)
  })
  return {
    tooltip: {
      trigger: 'axis',
      padding: 0,
      axisPointer: {
        type: 'line',
        lineStyle: {
          type: 'solid'
        }
      },
      backgroundColor: '#ffffff',
      borderWidth: 1,
      borderColor: 'rgba(0,0,0,0.2)',
      formatter: function(params) {
        var name1 = params[0].name
        var str = `<div class="tooltip">
              <div class="tooltip-title note-circle-blue">${name1}</div>
              <div class="tooltip-content">
                <span style="margin-right:5px" class="tooltip-title-left">${that.$t(
    'statistics.interfaceCallCount'
  )}</span>
                <sapn class="tooltip-title-right"> ${params[0].value} </sapn>
              </div>
         </div>`
        return str
      }
    },
    grid: {
      top: 20,
      left: 100,
      right: 50,
      bottom: 50
    },
    xAxis: {
      type: 'category',
      data: xAxis
    },
    yAxis: {
      type: 'value',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        lineStyle: {
          // 使用深浅的间隔色
          color: 'rgba(0,0,0,0.2)',
          type: 'dashed'
        }
      }
    },
    series: [
      {
        data: data,
        type: 'line',
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#E3EBFC' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#F9FAFE' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        itemStyle: {
          normal: {
            color: '#5A8BED',
            lineStyle: {
              color: '#5A8BED'
            }
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/statistics/apiStatistics/apiLineChar.js